import React from 'react'
import { NavLink } from 'react-router-dom'
import { Body1 } from '../../../layouts/TextStyles'
import Document from '../../../assets/icons/Documents/Copy-Document-Filled.svg'
import styled from '@emotion/styled'
import { ui, tone } from '../../../utils/uiTokens'

const MenuItem = ({ path, title, badge = 0, overdue = 0 }: { path: string; title: string; badge?: number; overdue?: number }) => {
    return (
        <li>
            <NavLink to={path}>
                {({ isActive }) => (
                    <LinkContainer active={isActive}>
                        <img
                            alt="document-copyw"
                            src={Document}
                        />
                        <Body1>{title}</Body1>
                        {badge > 0 && <Badge overdue={overdue > 0}>{badge}</Badge>}
                    </LinkContainer>
                )}
            </NavLink>
        </li>
    )
}

export { MenuItem }

const LinkContainer = styled.div<{ active: boolean }>`
    margin: 4px 0;
    display: grid;
    grid-template-columns: 18px 1fr auto;
    align-items: center;
    text-align: left;
    gap: 10px;
    padding: 10px;
    border-radius: 12px;
    background-color: ${({ active }) => (active ? ui.pinkSoft : 'transparent')};
    transition: background-color 0.15s ease;

    img {
        width: 18px;
        height: 18px;
        opacity: ${({ active }) => (active ? 1 : 0.45)};
    }

    p {
        font-size: 14px;
        font-weight: ${({ active }) => (active ? 600 : 400)};
        color: ${({ active }) => (active ? ui.pink : ui.sub)};
    }

    &:hover {
        background-color: ${({ active }) => (active ? ui.pinkSoft : ui.surface)};

        p {
            color: ${({ active }) => (active ? ui.pink : ui.ink)};
        }
    }
`

const Badge = styled.span<{ overdue: boolean }>`
    min-width: 20px;
    padding: 1px 6px;
    border-radius: 100px;
    font-size: 11.5px;
    font-weight: 700;
    text-align: center;
    color: ${({ overdue }) => (overdue ? tone.bad.text : '#fff')};
    background: ${({ overdue }) => (overdue ? tone.bad.bg : ui.pink)};
    box-shadow: ${({ overdue }) => (overdue ? `inset 0 0 0 1px ${tone.bad.border}` : 'none')};
`
